import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';

const Tags = ( { row } ) => {
	const mapTags = useCallback( () => row.labels.map( tag => ( // labels on backend
		<Label
			key={ tag.id }
			size="mini"
			style={ {
				backgroundColor: tag.color,
				color: '#fff',
				marginBottom: '0.23333334em'
			} }
		>
			{ tag.text }
		</Label>
	) ), [ row.labels ] );

	return (
		<span>
			{ mapTags() }
		</span>
	);
};

Tags.propTypes = { row: PropTypes.object.isRequired };

export default memo( Tags );
